import { Search, HelpCircle } from "lucide-react";

export function HeroSearch() {
  return (
    <div className="relative mb-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl overflow-hidden">
      {/* Content */}
      <div className="relative z-10 text-center py-16 px-8">
        <div className="w-16 h-16 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center mx-auto mb-4">
          <HelpCircle className="w-8 h-8 text-white" />
        </div>

        <h1 className="text-4xl font-bold text-white mb-3">How can we help you?</h1>
        <p className="text-lg text-white mb-8">Search our knowledge base or browse categories below</p>

        {/* Search Bar */}
        <div className="max-w-2xl mx-auto">
          <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none">
              <Search className="w-5 h-5 text-gray-400" />
            </div>
            <input
              type="search"
              placeholder="Search for help articles, guides, or tutorials..."
              className="w-full h-14 pl-12 pr-4 border-0 rounded-xl text-base text-gray-900 placeholder-gray-500 shadow-xl focus:ring-4 focus:ring-white/30 focus:outline-none transition-all bg-white"
            />
          </div>

          {/* Popular Searches */}
          <div className="mt-4 flex items-center justify-center gap-2 flex-wrap">
            <span className="text-sm text-white font-medium">Popular:</span>
            <button className="px-3 py-1.5 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white rounded-full text-xs font-medium transition-colors">
              WhatsApp Setup
            </button>
            <button className="px-3 py-1.5 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white rounded-full text-xs font-medium transition-colors">
              AI Configuration
            </button>
            <button className="px-3 py-1.5 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white rounded-full text-xs font-medium transition-colors">
              Billing & Plans
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
